import { KYMW0900Model } from "../kymw0900.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { GetNotUseCoopRequestModel } from '../vo/kymw0900-get-not-use-coop-request.model';
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";

/**
 * 予約商品フラグ取得サービス
 *
 * @export GetNotUseCoopService
 * @class GetNotUseCoopService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetNotUseCoopService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetNotUseCoopService
   */
  private successFunc: Function;

  private model: KYMW0900Model;
  vo: GetNotUseCoopRequestModel;
  private succeed: () => void;
  private fail: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetNotUseCoopService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        UseCoop: {
          condition: {
            PCode: this.vo.pCode,
          },
          combination: this.vo.coopCodeList.map(c => {
            return {
              parameter: {
                CoopCode: PlessViewUtilsSub.nullToBlank(c.coopCode)
              }
            }
          })
        },
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetNotUseCoopService
   */
  execute(
    model: KYMW0900Model,
    vo: GetNotUseCoopRequestModel,
    successFunc: Function = null,
    s: () => void = null,
    f: () => void = null
  ): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.succeed = s;
    this.fail = f;
    this.send('getNotUseCoop', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPreOrderService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.notUseCoopName = data.CoopName;
      if (this.successFunc) {
        this.successFunc(data);
      }
      if (this.succeed) this.succeed();
    }
  }

  /**
   * async/await 記述用
   *
   * @param model
   * @param vo
   * @param successFunc
   * @returns Promise<void>
   */
  public executeAsync(model: KYMW0900Model, vo: GetNotUseCoopRequestModel, successFunc: Function = null): Promise<void> {
    return new Promise((resolve, reject) => {
      this.execute(
        model,
        vo,
        successFunc,
        () => resolve(),
        () => reject()
      );
    });
  }

  protected statusError(status: string, result: any) {
    super.statusError(status, result);
    if (this.fail) this.fail();
  }
}
